// coffeeListReducer Actions
export const ADD_COFFEE = 'ADD_COFFEE';
// currentCoffeeReducer Actions
export const CHANGE_CURRENT_COFFEE = 'CHANGE_CURRENT_COFFEE';
// showDetailsReducer Actions
export const TOGGLE_DETAILS = 'TOGGLE_DETAILS';